import React, { useState } from "react";
import OtpForm from "../otp/OtpForm";

const OtpPage = () => {
  const [showOtp, setShowOtp] = useState(false);
  const [otpResult, setOtpResult] = useState(null);
  const [payload, setPayload] = useState({
    otpId: "",
    phone: "",
    id: "",
  });

  const handleOtpSubmit = (otp) => {
    // console.log("OTP ที่กรอก:", otp);
    setOtpResult(otp);
    setShowOtp(false);
    // คุณอาจ redirect หรือทำอย่างอื่นต่อได้ เช่น navigate("/home")
  };

  const handleOtpClose = () => {
    // console.log("User closed OTP popup");
    setShowOtp(false);
  };

  // สมมติข้อมูล payload ถูก set หลัง consent
  const handleSimulateConsent = () => {
    setPayload({
      otpId: "abc123",
      phone: "0812345678",
      id: "1234567890123",
    });
    setShowOtp(true);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      {/* แสดงปุ่มทดสอบการส่ง payload */}
      {!showOtp && (
        <button
          className="px-6 py-3 bg-green-500 text-white rounded"
          onClick={handleSimulateConsent}
        >
          ทดสอบ Consent + OTP
        </button>
      )}

      {/* แสดง OTP Modal */}
      {showOtp && (
        <OtpForm
          mobile={payload.phone}
          onSubmit={handleOtpSubmit}
          onClose={handleOtpClose}
        />
      )}
    </div>
  );
};

export default OtpPage;





// import React from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import OtpForm from "../otp/OtpForm";

// const OtpPage = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { otpId, phone, mode, id } = location.state || {};


//   const handleOtpSubmit = (otp) => {
//     console.log("OTP ที่กรอก:", otp);
//     navigate("/home");
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 flex items-center justify-center">
//       <OtpForm onSubmit={handleOtpSubmit} />
//     </div>
//   );
// };

// export default OtpPage;
